module.exports = __webpack_public_path__ + "img/img_22@2x.4cc721c9.png";